import React, { useState, useEffect } from 'react';
import { FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';
import { API_BASE } from '../config';
import './TopBar.css';

const TopBar = () => {
  const [info, setInfo] = useState({ phone: '0546 664 16 02', email: 'info@dihiz.com', address: 'Cumhuriyet Mah. 19 Mayıs Cad. No:36/1 İtfaiye Binası' });

  useEffect(() => {
    fetch(`${API_BASE}/contact`)
      .then(r => r.json())
      .then(data => { if (data && data.info) setInfo(prev => ({ ...prev, ...data.info })); })
      .catch(() => {});
  }, []);

  return (
    <div className="topbar">
      <div className="topbar-container">
        <div className="topbar-left">
          <a href={`tel:${info.phone?.replace(/\s/g, '')}`} className="topbar-item">
            <FaPhone className="topbar-icon" />
            <span>{info.phone}</span>
          </a>
          <a href={`mailto:${info.email}`} className="topbar-item">
            <MdEmail className="topbar-icon" />
            <span>{info.email}</span>
          </a>
        </div>
        <div className="topbar-right">
          <span className="topbar-item topbar-address">
            <FaMapMarkerAlt className="topbar-icon" />
            <span>{info.address}</span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
